import { Shield, ShieldAlert, ShieldOff, ShieldCheck, Clock } from 'lucide-react';
import { cn } from '../../utils/cn';

interface ProtectionStatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
  showIcon?: boolean;
}

const STATUS_CONFIG: Record<string, {
  label: string;
  icon: typeof Shield;
  bgColor: string;
  textColor: string;
  iconColor: string;
}> = {
  protected: {
    label: 'Protected',
    icon: ShieldCheck,
    bgColor: 'bg-success-100',
    textColor: 'text-success-700',
    iconColor: 'text-success-500',
  },
  pending: {
    label: 'Pending',
    icon: Clock,
    bgColor: 'bg-warning-100',
    textColor: 'text-warning-700',
    iconColor: 'text-warning-500',
  },
  expired: {
    label: 'Expired',
    icon: ShieldAlert,
    bgColor: 'bg-neutral-100',
    textColor: 'text-neutral-700',
    iconColor: 'text-neutral-500',
  },
  open: {
    label: 'Open',
    icon: ShieldOff,
    bgColor: 'bg-primary-100',
    textColor: 'text-primary-700',
    iconColor: 'text-primary-500',
  },
};

function ProtectionStatusBadge({
  status,
  size = 'sm',
  showIcon = true
}: ProtectionStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        config.bgColor,
        config.textColor,
        sizeClasses[size]
      )}
    >
      {showIcon && <Icon className={cn(iconSizes[size], config.iconColor)} />}
      {config.label}
    </span>
  );
}

export default ProtectionStatusBadge;
